module.exports = __webpack_public_path__ + "static/media/1.e7d38d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/28608/1.jpg
// module id = 635
// module chunks = 0